<template>
  <aside class="iv2-extra-nav text-center">
    <nav class="iv2-extra-nav__sub-menu theme__extra-nav--sub-menu">
      <ul class="iv2-extra-nav__sub-list list-unstyled">
        <li v-for="nav in extra" :key="nav.id" class="iv2-extra-nav__sub-item">
          <router-link
            v-if="nav.link_type == 'internal'"
            :to="nav.link_href + lang + query"
            :target="nav.target_type"
            class="iv2-extra-nav__sub-link"
            @click.native="toPageTop()"
          >
            <div class="iv2-extra-nav__sub-item-content">
              <i
                class="iv2-extra-nav__sub-item-icon d-block"
                :class="nav.item_icon"
              ></i>
              <span class="iv2-extra-nav__sub-item-text d-block">{{
                nav.item_name
              }}</span>
            </div>
          </router-link>
          <a
            v-else-if="nav.link_type == 'external'"
            :href="nav.link_href"
            :target="nav.target_type"
            @click="closeMenu"
            rel="noopener"
            class="iv2-extra-nav__sub-link"
          >
            <div class="iv2-extra-nav__sub-item-content">
              <i
                class="iv2-extra-nav__sub-item-icon d-block"
                :class="nav.item_icon"
              ></i>
              <span class="iv2-extra-nav__sub-item-text d-block">{{
                nav.item_name
              }}</span>
            </div>
          </a>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  props: {
    extra: Array,
  },

  data() {
    return {
      query: "",
      lang: "",
    };
  },

  mounted() {
    if (this.$route.query.mode == "preview") {
      this.query = "?mode=preview";
    }
    if (this.$route.query.hl) {
      this.lang = "?hl=" + this.$route.query.hl;
    }
  },

  methods: {
    closeMenu() {
      var nav = document.getElementsByClassName("iv2-nav");
      var body = document.body;
      nav[0].classList.remove("active");
      body.classList.remove("noscroll");
    },

    toPageTop() {
      let currentPageIsTop = this.$route.path === "/";

      if (currentPageIsTop) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.iv2-extra-nav {
  .iv2-extra-nav__sub-menu {
    .iv2-extra-nav__sub-list {
      .iv2-extra-nav__sub-item {
        height: 120px;
        position: relative;
        &:not(:last-child)::after {
          content: "";
          width: 100px;
          height: 1px;
          background-color: #fff;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      .iv2-extra-nav__sub-link {
        -webkit-transition: 0.3s;
        transition: 0.3s;
        color: #fff;
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
          opacity: 0.5;
        }
      }

      .iv2-extra-nav__sub-item-content {
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
        width: calc(100% - 20px);

        .iv2-extra-nav__sub-item-icon {
          font-size: 20px;
          margin-bottom: 10px;
        }

        .iv2-extra-nav__sub-item-text {
          font-size: 16px;
          font-weight: bold;
          line-height: 1.3;
        }
      }
    }
  }
}

/* TABLET or SP */
@media (max-width: 1199px) {
  .iv2-extra-nav {
    .iv2-extra-nav__sub-menu {
      .iv2-extra-nav__sub-list {
        display: flex;
        flex-direction: row-reverse;
        .iv2-extra-nav__sub-item {
          height: 80px;
          width: 80px;
          &:not(:last-child)::after {
            width: 1px;
            height: calc(100% - 20px);
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
        }

        .iv2-extra-nav__sub-item-content {
          width: calc(100% - 10px);
          .iv2-extra-nav__sub-item-icon {
            font-size: 18px;
            margin-bottom: 5px;
          }

          .iv2-extra-nav__sub-item-text {
            font-size: 10px;
          }
        }
      }
    }
  }
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
  .iv2-extra-nav {
    .iv2-extra-nav__sub-menu {
      .iv2-extra-nav__sub-list {
        .iv2-extra-nav__sub-item {
          height: 80px;
          width: 80px;
        }
      }
    }
  }
}

/* SP Only */
@media (max-width: 767px) {
  .iv2-extra-nav {
    .iv2-extra-nav__sub-menu {
      .iv2-extra-nav__sub-list {
        .iv2-extra-nav__sub-item {
          height: 60px;
          width: 60px;
        }

        .iv2-extra-nav__sub-item-content {
          .iv2-extra-nav__sub-item-icon {
            font-size: 14px;
          }

          .iv2-extra-nav__sub-item-text {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>
